import ColorTokens from '@hologram-dimension/tokens/colors';
import { FullHeightCalculatorHOC, HoloHelmet } from 'common-js/components';
import { type FC } from 'react';
import { type RouteComponentProps } from 'react-router';
import DataPlans from './DataPlans';

interface PlansProps extends RouteComponentProps<{}, RouterQueryParams> {}

const Plans: FC<PlansProps> = () => (
  <>
    <HoloHelmet title="Data plans" />
    <FullHeightCalculatorHOC
      accountForDrawer
      backgroundColor={ColorTokens.DdsColorBackgroundAlternative}
    >
      <div className="billing-container SimsTagManager">
        <DataPlans />
      </div>
    </FullHeightCalculatorHOC>
  </>
);

export default Plans;
